/** Panel o'ng tomonga qadalganmi: shu qurilmada (chap menyu yig'ilishi kabi), boshqa tablar ergashadi. */
import { useSyncExternalStore } from "react";

export const PINNED_KEY = "dh.widgets.pinned";
const listeners = new Set<() => void>();

function read(): boolean {
  try {
    return localStorage.getItem(PINNED_KEY) === "1";
  } catch {
    return false;
  }
}

let pinned = typeof window !== "undefined" && read();

export function setPinned(value: boolean) {
  pinned = value;
  try {
    localStorage.setItem(PINNED_KEY, value ? "1" : "0");
  } catch {
    /* ixtiyoriy: maxfiy rejim */
  }
  listeners.forEach((l) => l());
}

function subscribe(listener: () => void) {
  const onStorage = (e: StorageEvent) => {
    if (e.key === PINNED_KEY) {
      pinned = e.newValue === "1";
      listener();
    }
  };
  listeners.add(listener);
  window.addEventListener("storage", onStorage);
  return () => {
    listeners.delete(listener);
    window.removeEventListener("storage", onStorage);
  };
}

export function usePinned(): boolean {
  return useSyncExternalStore(subscribe, () => pinned);
}

/** Qadalgan ustun faqat keng ekranda (>= 1024px); torda panel oddiy ochiladi */
const WIDE = "(min-width: 1024px)";
export function useWideScreen(): boolean {
  return useSyncExternalStore(
    (l) => {
      const m = window.matchMedia(WIDE);
      m.addEventListener("change", l);
      return () => m.removeEventListener("change", l);
    },
    () => window.matchMedia(WIDE).matches,
  );
}
